// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__iqVdV","box":"WorkspacesBox_box__1ygCi","node":"WorkspacesBox_node__aE80e"};